'use client';
import { css } from '@wanteddev/wds-engine';
import { createResponsiveStyle } from '../../utils/index.mjs';

// src/components/flex-box/style.ts
var flexBoxStyle = ({ xs, sm, md, lg, xl, ...props }) => (theme) => css`
    display: flex;
    ${flexibleStyle(props)}

    ${createResponsiveStyle(
  { xs, sm, md, lg, xl },
  theme
)(
  (params) => css`
        ${flexibleStyle(params)}
        ${params?.sx}
      `
)}
  `;
var flexibleStyle = ({
  flexDirection,
  flexWrap,
  justifyContent,
  alignItems,
  alignContent,
  order,
  flex,
  flexGrow,
  flexShrink,
  alignSelf,
  flexBasis,
  gap
} = {}) => css`
  ${gap !== void 0 && css`
    gap: ${gap};
  `}
  ${flexDirection !== void 0 && css`
    flex-direction: ${flexDirection};
  `}
  ${flexWrap !== void 0 && css`
    flex-wrap: ${flexWrap};
  `}
	${justifyContent !== void 0 && css`
    justify-content: ${justifyContent};
  `}
	${alignItems !== void 0 && css`
    align-items: ${alignItems};
  `}
	${alignContent !== void 0 && css`
    align-content: ${alignContent};
  `}
	${order !== void 0 && css`
    order: ${order};
  `}
	${flex !== void 0 && css`
    flex: ${flex};
  `}
	${flexGrow !== void 0 && css`
    flex-grow: ${flexGrow};
  `}
	${flexShrink !== void 0 && css`
    flex-shrink: ${flexShrink};
  `}
	${alignSelf !== void 0 && css`
    align-self: ${alignSelf};
  `}
  ${flexBasis !== void 0 && css`
    align-self: ${flexBasis};
  `}
`;

export { flexBoxStyle };
